module.exports = __webpack_public_path__ + "img/logo-ytrack-gray.ed0caca9.png";